import React from "react"
import {EmbedTypeConfig} from "../embed-type-config";

export const EMBED_GOOGLE_MAP_CONFIG : EmbedTypeConfig = {
    name        : 'Google Map',
    icon        : 'i5-google-maps',
    iconSvg     : 'isvg-google-maps',
    description : 'Embeded Google Map',
    embedCode   : '',
    projectIcon : 'googleMap',                  // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['google.com/maps'],           // required for embedCode content search for autodetect EmbedType


    embedCodeLabel  : 'Google Maps Embed Code',
    helpContent     : 'To get the Google Maps embed code, open Google Maps, search for your desired location, click "Share," choose "Embed a map," and then copy the HTML code.'
}
